<template>
    <div @click="markAsRead()" class="general-interes">

        <span class="name" v-if="hasName"
              v-text="notification.user_from.full_name">
        </span>

        <span class="name" v-else-if="hasTitle"
              v-text="notification.payload.title">
        </span>

        <span class="notification-description"
              v-if="hasMessage"
              v-html="notification.payload.message"></span>

        <span class="time" v-text="diffForHumans(notification.created_at)"></span>

    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers'

export default {

    mixins:[Helpers],

    props: ['value'],

    data() {
        return {
            notification: this.value,
        }
    },

    methods: {
        markAsRead() {
            let redirectTo = null

            console.log(this.notification)

            if (this.notification.type == 'journal-page') {
                redirectTo = `/journal/${this.notification.post.slug}`
            }

            if (this.notification.type == 'list-page') {
                redirectTo = `/${this.notification.list.user.username}/list/${this.notification.list.slug}`
            }

            if (this.notification.type == 'destination-page') {
                redirectTo = `/destination/${this.notification.city.slug}`
            }

            if (this.notification.type == 'spot-page') {
                redirectTo = `/${this.notification.recommendation.city.slug}/${this.notification.recommendation.slug}`
            }

            if (this.notification.type == 'marketing') {
                redirectTo = '/'
                if (this.notification.payload.hasOwnProperty('url')) {
                    redirectTo = this.notification.payload.url
                }
            }

            axios.post(`/notification/read/${this.notification.id}`, this.notification)
                .then((response) => {
                    if (redirectTo) {
                        window.location.href = redirectTo;
                    }
                });
        },
    },

    computed: {

        hasTitle() {
            return this.notification.payload.hasOwnProperty('title') && (this.notification.payload.title != '' || this.notification.payload.title != null);
        },

        hasMessage() {
            return this.notification.payload &&
                this.notification.payload.hasOwnProperty('message') &&
                this.notification.payload.message;
        },

        hasName() {
            return this.notification.user_from
        }
    }
}
</script>
<style>
.notification-description a {
    text-decoration: none !important;
    color: inherit;
}
</style>
